var map = {
	"./Bildschirmfoto-2021-03-04-um-16.36.00.webp": 96,
	"./Leipzig_Bild.webp": 97,
	"./berlin-news-01.webp": 98,
	"./berlin-news-02.webp": 99,
	"./berlin-news-03.webp": 100,
	"./karte_gohlis1.webp": 101,
	"./karte_moeckern.webp": 102,
	"./leipzig-news-01.webp": 103,
	"./leipzig-news-02.webp": 104,
	"./leipzig-news-03.webp": 105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95;